export const groupByPredicate = <T>(
  values: T[],
  predicate: (v: T) => string
) => {
  return values.reduce((acc: { [key: string]: T[] }, v) => {
    const predicateValue = predicate(v);
    const existedGroup = acc[predicateValue];

    if (!existedGroup) {
      acc[predicateValue] = [v];
    } else {
      acc[predicateValue] = [...existedGroup, v];
    }
    return acc;
  }, {});
};
